// assets
import AppstoreAddOutlined from '@ant-design/icons/AppstoreAddOutlined';

// type
import { NavItemType } from 'types/menu';
import { SafetyOutlined } from '@ant-design/icons';

// ==============================|| MENU ITEMS - Pemitandinpections ||============================== //

const pemitandinpections: NavItemType = {
    id: 'group-catalogs',
    title: 'Permit & Inspections',
    icon: AppstoreAddOutlined,
    type: 'group',
    children: [
        {
            id: 'catalogs',
            title: 'Permit & Inspection Types',
            subtitle: 'Manage permit types across Global and Municipality scopes.',
            type: 'item',
            url: '/permit&Inspections',
            icon: SafetyOutlined,
            featureID: 16,
        },
    ]

};

export default pemitandinpections;


